import { Box } from '@chakra-ui/react'
import React from 'react'

import {
  SearchableCombobox,
  type SearchableComboboxProps,
} from '@mangovoice/mango-ui'

import { getNodeSelectFieldStyles } from './nodeInputStyles'
import { NodeLabel } from './NodeLabel'

export interface NodeSearchableComboboxProps extends Omit<
  SearchableComboboxProps,
  'inputProps'
> {
  label: string
  required?: boolean
  inputProps?: SearchableComboboxProps['inputProps']
}

export const NodeSearchableCombobox: React.FC<NodeSearchableComboboxProps> = ({
  label,
  required = false,
  inputProps,
  ...comboboxProps
}) => {
  const className = ['nodrag', 'nowheel', inputProps?.className]
    .filter(Boolean)
    .join(' ')

  return (
    <Box
      position="relative"
      width="100%"
      className="nodrag nowheel"
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      onWheel={(event) => event.stopPropagation()}
    >
      <SearchableCombobox
        {...comboboxProps}
        inputProps={{
          ...getNodeSelectFieldStyles(false),
          ...inputProps,
          className,
        }}
      />
      <NodeLabel label={label} required={required} />
    </Box>
  )
}
